<template>
    <div>
        <choice-wrap>
            <template v-slot:title>
                <img src="../../assets/images/setup/plug.svg" alt="" class="mr-3">
                <h3>What type of energy do you use?</h3>
            </template>
            <choice v-model="selected.currentEnergySource" :errors.sync="errors.currentEnergySource" :data="data.currentEnergySource" show-button-title></choice>
        </choice-wrap>
        <slide-y-up-transition>
            <choice-wrap v-if="energySourceIs(['D', 'E'])">
                <template v-slot:title>
                    <img src="../../assets/images/setup/meter.svg" alt="" class="mr-3">
                    <h3>Do you have an Economy 7 meter? <i class="fa fa-question-circle-o h5 text-info font-weight-normal"  v-tooltip="{ content: tooltips.economy7 , trigger: 'click'}" ></i></h3>
                </template>
                <choice v-model="selected.currentEconomy7State" :errors.sync="errors.currentEconomy7State" :data="data.currentEconomy7State"   show-button-title></choice>
            </choice-wrap>
        </slide-y-up-transition>
        <slide-y-up-transition>
            <choice-wrap v-if="energySourceIs('D')">
                <template v-slot:title>
                    <img src="../../assets/images/setup/truck.svg" alt="" class="mr-3">
                    <h3>Are you using the same supplier for Gas and Electricity?</h3>
                </template>
                <choice v-model="selected.currentEnergyBySameSupplier" :errors.sync="errors.currentEnergyBySameSupplier" :data="data.currentEnergyBySameSupplier" show-button-title></choice>
            </choice-wrap>
        </slide-y-up-transition>

        <slide-y-up-transition>
            <choice-wrap v-if="energySourceIs('D') && selected.currentEnergyBySameSupplier === '1'">
                <template v-slot:title>
                    <img src="../../assets/images/setup/light.svg" alt="" class="mr-3">
                    <h3>Select your Energy Supplier</h3>
                </template>
                <choice v-model="currentEnergySupplier" :errors.sync="errors.currentEnergySupplier" :data="dualSuppliers" :buttons-data="dualSuppliersButtons" show-buttons show-button-images show-select-control select-placeholder="All suppliers"></choice>
            </choice-wrap>
        </slide-y-up-transition>
        <slide-y-up-transition>
            <choice-wrap v-if="energySourceIs('D') && selected.currentEnergyBySameSupplier === '1'">
                <template v-slot:title>
                    <img src="../../assets/images/setup/pound.svg" alt="" class="mr-3">
                    <h3>What is your current Energy Tariff? <i class="fa fa-question-circle-o h5 text-info font-weight-normal" v-tooltip="{ content: tooltips.tariff , trigger: 'click'}" ></i></h3>
                </template>
                <choice v-model="currentEnergyTariff" :errors.sync="errors.currentEnergyTariff" :data="electricityTariff" :show-buttons="false" show-select-control select-placeholder="Please select"></choice>
            </choice-wrap>
        </slide-y-up-transition>
        <slide-y-up-transition>
            <choice-wrap v-if="energySourceIs('D') && selected.currentEnergyBySameSupplier === '1'">
                <template v-slot:title>
                    <img src="../../assets/images/setup/creditcard.svg" alt="" class="mr-3">
                    <h3>How do you pay for your Energy?</h3>
                </template>
                <choice v-model="currentEnergyPaymentScheme" :errors.sync="errors.currentEnergyPaymentScheme" :data="electricityPaymentSchemes"   show-button-title show-button-description></choice>
            </choice-wrap>
        </slide-y-up-transition>
        <slide-y-up-transition>
        <choice-wrap v-if="energySourceIs('E') || (energySourceIs('D') && selected.currentEnergyBySameSupplier === '0')">
            <template v-slot:title>
                <img src="../../assets/images/setup/light.svg" alt="" class="mr-3">
                <h3>Select your Electricity Supplier</h3>
            </template>
            <choice v-model="selected.currentElectricitySupplier" :errors.sync="errors.currentElectricitySupplier" :data="electricitySuppliers" :buttons-data="electricitySuppliersButtons" show-buttons show-button-images show-select-control select-placeholder="All suppliers"></choice>
        </choice-wrap>
        </slide-y-up-transition>
        <slide-y-up-transition>
        <choice-wrap v-if="energySourceIs('E') || (energySourceIs('D') && selected.currentEnergyBySameSupplier === '0')">
            <template v-slot:title>
                <img src="../../assets/images/setup/pound.svg" alt="" class="mr-3">
                <h3>What is your current Electricity Tariff? <i class="fa fa-question-circle-o h5 text-info font-weight-normal"  v-tooltip="{ content: tooltips.tariff , trigger: 'click'}"></i></h3>
            </template>
            <choice v-model="selected.currentElectricityTariff" :errors.sync="errors.currentElectricityTariff" :data="electricityTariff" :show-buttons="false" show-select-control select-placeholder="Please select"></choice>
        </choice-wrap>
        </slide-y-up-transition>
        
        <slide-y-up-transition>
        <choice-wrap v-if="energySourceIs('E') || (energySourceIs('D') && selected.currentEnergyBySameSupplier === '0')">
            <template v-slot:title>
                <img src="../../assets/images/setup/creditcard.svg" alt="" class="mr-3">
                <h3>How do you pay for your electricity?</h3>
            </template>
            <choice v-model="selected.currentElectricityPaymentScheme" :errors.sync="errors.currentElectricityPaymentScheme" :data="electricityPaymentSchemes"   show-button-title show-button-description></choice>
        </choice-wrap>
        </slide-y-up-transition>
        <slide-y-up-transition>
        <choice-wrap v-if="energySourceIs('G')  || (energySourceIs('D') && selected.currentEnergyBySameSupplier === '0')">
            <template v-slot:title>
                <img src="../../assets/images/setup/flame.svg" alt="" class="mr-3">
                <h3>Select your Gas Supplier</h3>
            </template>
            <choice v-model="selected.currentGasSupplier" :errors.sync="errors.currentGasSupplier" :data="gasSuppliers" :buttons-data="gasSuppliersButtons" show-button-images show-select-control select-placeholder="All suppliers"></choice>
        </choice-wrap>
        </slide-y-up-transition>
        <slide-y-up-transition>
        <choice-wrap v-if="energySourceIs('G') || (energySourceIs('D') && selected.currentEnergyBySameSupplier === '0')">
            <template v-slot:title>
                <img src="../../assets/images/setup/pound.svg" alt="" class="mr-3">
                <h3 >What is your current Gas Tariff? <i class="fa fa-question-circle-o h5 text-info font-weight-normal"  v-tooltip="{ content: tooltips.tariff , trigger: 'click'}" ></i></h3>
            </template>
            <choice v-model="selected.currentGasTariff" :errors.sync="errors.currentGasTariff" :data="gasTariff" :show-buttons="false" show-select-control select-placeholder="Please select"></choice>
        </choice-wrap>
        </slide-y-up-transition>
        <slide-y-up-transition>
        <choice-wrap v-if="energySourceIs('G') || (energySourceIs('D') && selected.currentEnergyBySameSupplier === '0')">
            <template v-slot:title>
                <img src="../../assets/images/setup/creditcard.svg" alt="" class="mr-3">
                <h3>How do you pay for your gas?</h3>
            </template>
            <choice v-model="selected.currentGasPaymentScheme" :errors.sync="errors.currentGasPaymentScheme" :data="gasPaymentSchemes"   show-button-title show-button-description></choice>
        </choice-wrap>
        </slide-y-up-transition>
        <slide-y-up-transition>
        <choice-wrap v-if="energySourceIs(['D','E','G']) && 1 === 2"> <!-- warm home is disabled for now -->
            <template v-slot:title>
                <img src="../../assets/images/setup/home.svg" alt="" class="mr-3">
                <h3>I use "Warm Home Discount"</h3>
            </template>
            <choice v-model="selected.currentWarmHomeState" :errors.sync="errors.currentWarmHomeState" :data="data.currentWarmHomeState" show-button-title></choice>
        </choice-wrap>
        </slide-y-up-transition>
    </div>
</template>

<script>
import ChoiceWrap from "../../components/setup/ChoiceWrap";
import Choice from "../../components/setup/Choice";
import SetupValidationHelper from "../../mixins/SetupValidationHelper";
import SetupChoiceUpdate from "../../mixins/SetupChoiceUpdate";
import {SlideYUpTransition} from 'vue2-transitions'
import store from '../../store'
import api from '../../utils/api'

export default {
        name: "Current",
        components: {Choice, ChoiceWrap, SlideYUpTransition},
        mixins: [SetupValidationHelper,SetupChoiceUpdate],
        data: function () {
            return {
                tooltips: {
                    tariff: 'Tariff information can be found on your energy bill',
                    economy7: 'Economy 7 means you will have a day and night rate specified in your energy bill breakdown section. Your supply number would also start with 02.'
                },
                nextRouteName: 'SetupEnergy',
                currentEnergySupplier: null,
                currentEnergyTariff: null,
                currentEnergyPaymentScheme: null,
                electricityTariff: [],
                gasTariff: [],
                defaults: {
                    currentWarmHomeState: "0"
                },
                selected: {
                    currentEnergySource: null,
                    currentEnergyBySameSupplier: null,
                    currentElectricitySupplier: null,
                    currentElectricityTariff: null,
                    currentEconomy7State: null,
                    currentElectricityPaymentScheme: null,
                    currentGasSupplier: null,
                    currentGasTariff: null,
                    currentGasPaymentScheme: null,
                    currentWarmHomeState: null,
                },
                errors: {
                    currentEnergySource: [],
                    currentEnergyBySameSupplier: [],
                    currentElectricitySupplier: [],
                    currentElectricityTariff: [],
                    currentEconomy7State: [],
                    currentElectricityPaymentScheme: [],
                    currentGasSupplier: [],
                    currentGasTariff: [],
                    currentGasPaymentScheme: [],
                    currentEnergySupplier: [],
                    currentEnergyTariff: [],
                    currentEnergyPaymentScheme: [],
                    currentWarmHomeState: [],
                },
            }
        },
        methods: {
            energySourceIs: function (sourceType) {
                if (!Array.isArray(sourceType)) {
                    sourceType = [sourceType]
                }
                return sourceType.indexOf(this.selected.currentEnergySource) >= 0
            },
            validate: function () {
                this.resetErrors()
                if(!this.selected.currentEnergySource){
                    this.errors.currentEnergySource.push('Please choose what energy you are using!')
                    return;
                }
                if(this.energySourceIs('D') && !this.selected.currentEnergyBySameSupplier){
                    this.errors.currentEnergyBySameSupplier.push('Please choose if you are using same supplier for gas and electricity')
                }
                
                if(this.energySourceIs('D') && this.isEnergyBySameSupplier && !this.currentEnergySupplier){
                    this.errors.currentEnergySupplier.push('Please select your energy supplier!')
                }

                if((this.energySourceIs(['D', 'E'])) && !this.selected.currentElectricitySupplier){
                    this.errors.currentElectricitySupplier.push('Please select your electricity supplier!')
                }
                if((this.energySourceIs(['D', 'E'])) && !this.selected.currentElectricityTariff){
                    this.errors.currentElectricityTariff.push('Please select your electricity tariff!')
                }
                if((this.energySourceIs(['D', 'E'])) && !this.selected.currentEconomy7State){
                    this.errors.currentEconomy7State.push('Please select do you use Economy 7 meter!')
                }
                if((this.energySourceIs(['D', 'E'])) && !this.selected.currentElectricityPaymentScheme){
                    this.errors.currentElectricityPaymentScheme.push('Please select your electricity payment scheme!')
                }
                if(this.energySourceIs(['D', 'G']) && !this.selected.currentGasSupplier){
                    this.errors.currentGasSupplier.push('Please select your gas supplier!')
                }
                if(this.energySourceIs(['D', 'G']) && !this.selected.currentGasTariff){
                    this.errors.currentGasTariff.push('Please select your gas tariff!')
                }
                if(this.energySourceIs(['D', 'G']) && !this.selected.currentGasPaymentScheme){
                    this.errors.currentGasPaymentScheme.push('Please select your gas payment scheme!')
                }
            }
        },
        computed: {
            data: function () {
                return this.$store.getters["setup/stepTwoData"]
            },
            dualSuppliers: function (){
                return this.data.suppliers.filter( supplier => supplier.type === 'D')
            },
            electricitySuppliers: function (){
              return this.data.suppliers.filter( supplier => supplier.type === 'D' || supplier.type === 'E')
            },
            gasSuppliers: function (){
              return this.data.suppliers.filter( supplier => supplier.type === 'D' || supplier.type === 'G')
            },
            dualSuppliersButtons: function (){
                return this.dualSuppliers.filter( supplier => supplier.featured )
            },
            electricitySuppliersButtons: function (){
              return this.electricitySuppliers.filter( supplier => supplier.featured )
            },
            gasSuppliersButtons: function (){
              return this.gasSuppliers.filter( supplier => supplier.featured )
            },
            electricityPaymentSchemes: function (){
                if(!this.selected.currentElectricityTariff || this.electricityTariff.length === 0){
                    return this.data.currentPaymentSchemes
                }
    
                if(this.electricityTariff[0].id === null){
                    return this.data.currentPaymentSchemes
                }
                
                let that = this;
                that.selected.currentElectricityPaymentScheme = null
                return this.data.currentPaymentSchemes.filter(v => {
                    let tariff = that.electricityTariff.filter(v=> v.id === that.selected.currentElectricityTariff)[0];
                    return tariff.payment_methods.indexOf(v.id) >=0
                })
            },
            gasPaymentSchemes: function (){
                if(!this.selected.currentGasTariff || this.gasTariff.length === 0){
                    return this.data.currentPaymentSchemes
                }
    
                if(this.gasTariff[0].id === null){
                    return this.data.currentPaymentSchemes
                }
    
                let that = this;
                that.selected.currentGasPaymentScheme = null
                return this.data.currentPaymentSchemes.filter(v => {
                    let tariff = that.gasTariff.filter(v=> v.id === that.selected.currentGasTariff)[0];
                    return tariff.payment_methods.indexOf(v.id) >=0
                })
            },
            warmHomeEligible: function (){
                let electricitySupplier = this.electricitySuppliers.filter( s => s.id === this.selected.currentElectricitySupplier).pop()
                if(electricitySupplier && electricitySupplier.warm){
                    return true
                }
                let gasSupplier = this.gasSuppliers.filter( s => s.id === this.selected.currentGasSupplier).pop()
                if(gasSupplier && gasSupplier.warm){
                    return true
                }
                return false
            },
            isEnergyBySameSupplier: function (){
                return this.selected.currentEnergyBySameSupplier === "1"
            }
        },
        watch: {
            'selected.currentElectricitySupplier' : function (newValue, oldValue) {
                if(!newValue){
                    this.electricityTariff = []
                    this.selected.currentElectricityTariff = null
                }
                if(oldValue === newValue){
                    return
                }
                if(this.isEnergyBySameSupplier){
                    this.selected.currentGasSupplier = newValue;
                }
                
                let that = this;
                
                that.electricityTariff = [{
                    id: null,
                    title: 'Loading ...',
                    disabled: true
                }]
                
                api.tariffs(
                    this.selected.currentElectricitySupplier,
                    this.$store.getters['setup/currentAddress'].region,
                    this.isEnergyBySameSupplier ? this.selected.currentEnergySource : 'E',
                    this.selected.currentEconomy7State
                ).then(result => {
                    if(result.data.data.length) {
                        that.electricityTariff = result.data.data;
                        let filtered = that.electricityTariff.filter(tariff => tariff.id != null && tariff.id === that.selected.currentElectricityTariff).length;
                        if(filtered === 0){
                            that.selected.currentElectricityTariff = null
                            if(that.isEnergyBySameSupplier){
                                that.currentEnergyTariff = null
                            }
                        }
                    }
                    else {
                        that.electricityTariff = [{
                            id: null,
                            title: 'No tariffs were found',
                            disabled: true
                        }]
    
                        that.selected.currentElectricityTariff = null
                    }
                })
            },
            'selected.currentGasSupplier' : function (newValue, oldValue) {
                if(!newValue){
                    this.gasTariff = []
                    this.selected.currentGasTariff = null
                }
                if(oldValue === newValue){
                    return
                }
                
                if(this.isEnergyBySameSupplier){
                    this.selected.currentElectricitySupplier = newValue;
                }
                let that = this;
    
                that.gasTariff = [{
                    id: null,
                    title: 'Loading ...',
                    disabled: true
                }]
                api.tariffs(
                    this.selected.currentGasSupplier,
                    this.$store.getters['setup/currentAddress'].region,
                    this.isEnergyBySameSupplier ? this.selected.currentEnergySource : 'G',
                    this.selected.currentEconomy7State
                ).then(result => {
                    if(result.data.data.length) {
                        that.gasTariff = result.data.data;
                        let filtered = that.gasTariff.filter(tariff => tariff.id === that.selected.currentGasTariff).length;
                        if(filtered === 0){
                            that.selected.currentGasTariff = null
                        }
                    }
                    else {
                        that.gasTariff = [{
                            id: null,
                            title: 'No tariffs were found',
                            disabled: true
                        }]
                        that.selected.currentGasTariff = null
                    }
                })
            },
            'selected.currentEnergyBySameSupplier' : function (newValue) {
                  if(newValue === "1"){
                      this.selected.currentGasSupplier = this.selected.currentElectricitySupplier;
                  }
            },
            currentEnergySupplier: function (newValue) {
                if(this.isEnergyBySameSupplier){
                    this.selected.currentElectricitySupplier = newValue;
                    this.selected.currentGasSupplier = newValue;
                }
            },
            currentEnergyTariff: function (newValue) {
                if(this.isEnergyBySameSupplier){
                    this.selected.currentElectricityTariff = newValue;
                    this.selected.currentGasTariff = newValue;
                }
            },
            currentEnergyPaymentScheme: function (newValue) {
                if(this.isEnergyBySameSupplier){
                    this.selected.currentElectricityPaymentScheme = newValue;
                    this.selected.currentGasPaymentScheme = newValue;
                }
            },
            electricityPaymentSchemes: function (newValue){
                if(newValue.length === 1){
                    this.selected.currentElectricityPaymentScheme = newValue[0].id
    
                    if(this.isEnergyBySameSupplier){
                        this.currentEnergyPaymentScheme = newValue[0].id
                    }
                }
            },
            gasPaymentSchemes: function (newValue){
                if(newValue.length === 1){
                    this.selected.currentGasPaymentScheme = newValue[0].id
                    if(this.isEnergyBySameSupplier){
                        this.currentEnergyPaymentScheme = newValue[0].id
                    }
                }
            },
            'selected.currentEconomy7State': function (newValue, oldValue){
                if(oldValue === null || newValue === oldValue){
                    return
                }
                this.electricityTariff = []
                this.selected.currentElectricityTariff = null
                this.selected.currentElectricitySupplier = null
                this.currentEnergySupplier = null
            }
        },
        mounted() {
            this.fillSelected();
            if(this.isEnergyBySameSupplier){
                if(this.selected.currentElectricitySupplier) {
                    this.currentEnergySupplier = this.selected.currentElectricitySupplier;
                }
                if(this.selected.currentElectricityTariff) {
                    this.currentEnergyTariff = this.selected.currentElectricityTariff;
                }
                if(this.selected.currentElectricityPaymentScheme) {
                    this.currentEnergyPaymentScheme = this.selected.currentElectricityPaymentScheme
                }
            }
        },
        beforeRouteEnter: (to, from, next) => {
            if(!store.getters['setup/stepTwoData'].suppliers.length){
              api.suppliers().then(result => {
                  store.commit('setup/setSuppliers', result.data.data)
                  next()
              })
            } else  {
              next()
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "../../sass/base";
    
    .warmHomeCheckbox {
    
        padding-left: 0;
        padding-right: 2rem;
        label.custom-control-label {
    
            padding-right: 2rem;
            &::before {
                top: 0.3rem;
                left: auto;
                right: 0;
                width: 1.25rem;
                height: 1.25rem;
            }
            &::after {
                top: 0.3rem;
                left: auto;
                right: 0;
                width: 1.25rem;
                height: 1.25rem;
                
            }
        }
    
        .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
            background-size: 10px;
        }
    }
    .fa.fa-question-circle-o {
        cursor: pointer;
    }
</style>
